import { ElementType } from "@archetypes/form";
import { MENTION_REGEX } from "@constants/generic";

export function replaceMentionTagsWithTokenString(htmlString: string, token: string) {
  return htmlString.replace(MENTION_REGEX, (match, id) => {
    return id ? `${token}${id}` : match;
  });
}

export function extractQuestionIdsFromMentionTag(expression: string | undefined) {
  if (!expression) {
    return [];
  }
  const dataIds = [];
  let match;

  while ((match = MENTION_REGEX.exec(expression)) !== null) {
    dataIds.push(match[1]);
  }

  return dataIds;
}

export function isQuestionAllowedInFormulaConfig(elementType: ElementType) {
  return (
    elementType === ElementType.Currency ||
    elementType === ElementType.Number ||
    elementType === ElementType.Formula ||
    elementType === ElementType.Rating ||
    elementType === ElementType.Aggregator ||
    elementType === ElementType.DatePicker
  );
}
